import APIClient from '../lib/api-client'

export class CollectAPI extends APIClient {
  form (data) {
    return this.post('/collect/forms', data, {
      params: { invisible: true }
    })
  }

  loadMerge ({xid, appId}) {
    return this.get(`/merge/${appId}/${xid}`)
  }
}

class CountryData extends APIClient {
  regions (alpha3CountryCode) {
    return this.get(`/subdivisions/by_country/${alpha3CountryCode}.json`).then(this.justData)
  }

  countries () {
    return this.get('/countries/all.json').justData().then(this.justData)
  }
}

export const countryData = new CountryData({
  withCredentials: false,
  baseURL: 'https://cdn.convrrt.com/assets/ISO-3166/data'
})
